import { render, staticRenderFns } from "./warning-success.vue?vue&type=template&id=0d658230&scoped=true"
import script from "./warning-success.vue?vue&type=script&lang=js"
export * from "./warning-success.vue?vue&type=script&lang=js"
import style0 from "./warning-success.vue?vue&type=style&index=0&id=0d658230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d658230",
  null
  
)

export default component.exports